import React from 'react'
import { Heading, LayoutPageWrapper } from 'goustouicomponents'
import css from './WhoWeAre.module.css'

const WhoWeAre = () => (
  <section className={css.wrapper}>
    <LayoutPageWrapper>
      <div className={css.contentContainer}>
        <div className={css.card}>
          <Heading type="h2" size="fontStyleXL" hasMargin={false}>
            Who are we?
          </Heading>
          <p className={css.cardContent}>
            We’re proud to be one of the fastest-growing companies in the UK. Powered by data and a love of food, we’re
            a recipe box company that’s disrupting the sector, and we’re passionate about our team and our customers.
          </p>
          <p className={css.cardContent}>
            Our dream? To be the most-loved way to eat dinner, and for every meal to leave the planet better off. Gousto
            is changing how people shop, cook and eat food at home. It’s an incredibly exciting time to join our team -
            and we’re such a friendly bunch!
          </p>
        </div>
      </div>
    </LayoutPageWrapper>
  </section>
)

export { WhoWeAre }
